// Shared response handler for admin pages.
//
// The admin pages authenticate with the `adminAuth` JWT in localStorage, which
// expires after 12h. The pages only check that the token EXISTS, not that it's
// still valid — so an expired token returns 401 and the page would silently
// render empty (no dealers, no rows) with no explanation. Pipe admin fetch
// responses through this: on 401/403 it clears the dead token and bounces to the
// login screen so re-authing restores everything.
//
// Usage:  fetch(`${API_BASE}/admin/...`, { headers }).then(adminJson)
export function adminJson(r) {
  if (r.status === 401 || r.status === 403) {
    localStorage.removeItem('adminAuth');
    window.location.href = '/admin/login';
    throw new Error('session expired');
  }
  return r.json();
}
